<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <h4 v-if="mData.viewMode == 'update'">Cập nhật bảng lương</h4>
          <h4 v-if="mData.viewMode == 'detail'">Chi tiết bảng lương</h4>
          <div class="text-right mb-1">
            <el-button
              class="pl-2"
              v-if="
                mData.viewMode == 'update' &&
                !salaryPeriodConfig &&
                mData.dataDefault.listFeature.includes('FT1103')
              "
              round
              @click="submitForm('importSalaryNoApproval')"
            >
              Lưu
            </el-button>
            <el-button
              class="pl-2"
              v-if="
                mData.viewMode == 'update' &&
                salaryPeriodConfig &&
                mData.dataDefault.listFeature.includes('FT1103')
              "
              round
              @click="submitForm('import')"
            >
              Chuyển duyệt
            </el-button>
            <el-button
              class="pl-2"
              v-if="
                mData.viewMode == 'detail' &&
                mData.isSealed === false &&
                salaryPeriodConfig &&
                mData.dataDefault.listFeature.includes('FT1104') &&
                mData.dataForm.sealed != 'NEW' &&
                mData.dataDefault.listSaledUserIds.includes(mData.currentUser.id)
              "
              round
              plain
              @click="submitForm('unApproval')"
            >
              Từ chối
            </el-button>
            <el-button
              class="pl-2"
              v-if="
                mData.viewMode == 'detail' &&
                mData.isSealed === false &&
                salaryPeriodConfig &&
                mData.dataDefault.listFeature.includes('FT1104') &&
                mData.dataForm.sealed != 'NEW' &&
                mData.dataDefault.listSaledUserIds.includes(mData.currentUser.id)
              "
              round
              plain
              @click="submitForm('approval')"
            >
              Duyệt
            </el-button>
            <el-button class="pl-2" round @click="fn_go()">Quay lại</el-button>
          </div>
        </div>
        <div class="main-body mt-1">
          <el-form
            ref="mySalaryPeriodForm"
            label-position="top"
            @submit.native.prevent
            :model="mData.dataForm"
            :rules="mData.validForm"
            label-width="120px"
            style="margin-left: 20px"
          >
            <b-row>
              <b-col md="12" sm="8">
                <el-form-item label="Tên kỳ lương" prop="name">
                  <el-input
                    :disabled="mData.viewMode == 'detail'"
                    v-model="mData.dataForm.name"
                    clearable
                    @change="
                      () => {
                        mData.dataForm.name = mData.dataForm.name.trim();
                      }
                    "
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="4" sm="4">
                <el-form-item label="Kỳ tính lương" prop="template_salary_period_id">
                  <el-select
                    disabled
                    v-model="mData.dataForm.template_salary_period_id"
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listSalaryPeriod"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="4" sm="6">
                <el-form-item label="Thời gian từ" prop="from_date">
                  <el-date-picker
                    disabled
                    v-model="mData.dataForm.from_date"
                    type="date"
                    placeholder=""
                    format="dd/MM/yyyy"
                  >
                  </el-date-picker>
                </el-form-item>
              </b-col>
              <b-col md="4" sm="6">
                <el-form-item label="Thời gian tới" prop="before_to_date">
                  <el-date-picker
                    disabled
                    v-model="mData.dataForm.before_to_date"
                    type="date"
                    placeholder=""
                    format="dd/MM/yyyy"
                  >
                  </el-date-picker>
                </el-form-item>
              </b-col>
              <b-col md="4" cols="6" v-if="salaryPeriodConfig === true">
                <el-form-item label="Số cấp duyệt" prop="sealed_level">
                  <el-select
                    :disabled="mData.viewMode == 'detail'"
                    v-model="mData.dataForm.sealed_level"
                    @change="changeSealedLevel"
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listSealedLevel"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="4" cols="6" v-if="salaryPeriodConfig === true">
                <el-form-item label=" " class="check-box_sequential">
                  <el-checkbox disabled v-model="mData.dataForm.is_sequential"
                    >Có tuần tự hay không</el-checkbox
                  >
                </el-form-item>
              </b-col>
            </b-row>
            <b-row v-if="salaryPeriodConfig === true">
              <b-col
                md="4"
                v-for="(item, index) in mData.dataForm.sealed_users"
                :key="index"
              >
                <el-form-item
                  :label="`Cấp duyệt ${index + 1}`"
                  :prop="`sealed_users[` + index + `].sealed_user_id`"
                >
                  <el-select
                    :disabled="mData.viewMode == 'detail'"
                    v-model="item.sealed_user_id"
                    @change="changeSealedUser(item.sealed_user_id, index)"
                    clearable
                    filterable
                    @input="forceUpdateUI"
                  >
                    <el-option
                      v-for="element in mData.dataDefault.listSealedUsers"
                      :key="element.id"
                      :label="element.administrative_info.name.full_name"
                      :value="element.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="4" md="12">
                <el-form-item label="Tải file lương" prop="file_id">
                  <div slot="label">
                    <span class="custom_label_requied">Tải file lương</span>
                  </div>
                  <el-upload
                    ref="upload"
                    :auto-upload="false"
                    list-type="text"
                    drag
                    action
                    :limit="mData.fileUploadOption.Template.limit"
                    :accept="mData.fileUploadOption.Template.accept"
                    :on-change="fn_uploadFileSalaryPeriod"
                    :on-preview="fn_previewFileSalaryPeriod"
                    :on-remove="fn_removeFileSalaryPeriod"
                    :file-list="mData.fileUploadOption.Template.fileList"
                    :multiple="false"
                    :disabled="mData.viewMode == 'detail' || mData.dataForm.name == ''"
                    :class="{
                      hide:
                        mData.viewMode == 'detail' ||
                        mData.fileUploadOption.Template.fileList.length > 0,
                      diable: mData.viewMode == 'detail' || mData.dataForm.name == '',
                    }"
                  >
                    <div v-if="mData.viewMode != 'detail'">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        Thả file vào đây hoặc <em>click để tải lên</em>
                      </div>
                    </div>
                  </el-upload>
                </el-form-item>
              </b-col>
              <b-col lg="4" md="12">
                <el-form-item label="Tải file thuế" prop="tax_file_id">
                  <div slot="label">
                    <span class="custom_label_requied">Tải file thuế</span>
                  </div>
                  <el-upload
                    ref="upload"
                    :auto-upload="false"
                    list-type="text"
                    drag
                    action
                    :limit="mData.fileUploadOption.Tax.limit"
                    :accept="mData.fileUploadOption.Tax.accept"
                    :on-change="fn_uploadFileTax"
                    :on-preview="fn_previewFileTax"
                    :on-remove="fn_removeFileTax"
                    :file-list="mData.fileUploadOption.Tax.fileList"
                    :multiple="false"
                    :disabled="mData.viewMode == 'detail' || mData.dataForm.name == ''"
                    :class="{
                      hide:
                        mData.viewMode == 'detail' ||
                        mData.fileUploadOption.Tax.fileList.length > 0,
                      diable: mData.viewMode == 'detail' || mData.dataForm.name == '',
                    }"
                  >
                    <div v-if="mData.viewMode != 'detail'">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        Thả file vào đây hoặc <em>click để tải lên</em>
                      </div>
                    </div>
                  </el-upload>
                </el-form-item>
              </b-col>
              <b-col lg="4" md="12">
                <el-form-item label="Tải file bảo hiểm" prop="insurance_file_id">
                  <div slot="label">
                    <span class="custom_label_requied">Tải file bảo hiểm</span>
                  </div>
                  <el-upload
                    ref="upload"
                    :auto-upload="false"
                    list-type="text"
                    drag
                    action
                    :limit="mData.fileUploadOption.Insurance.limit"
                    :accept="mData.fileUploadOption.Insurance.accept"
                    :on-change="fn_uploadFileInsurance"
                    :on-preview="fn_previewFileInsurance"
                    :on-remove="fn_removeFileInsurance"
                    :file-list="mData.fileUploadOption.Insurance.fileList"
                    :multiple="false"
                    :disabled="mData.viewMode == 'detail' || mData.dataForm.name == ''"
                    :class="{
                      hide:
                        mData.viewMode == 'detail' ||
                        mData.fileUploadOption.Insurance.fileList.length > 0,
                      diable: mData.viewMode == 'detail' || mData.dataForm.name == '',
                    }"
                  >
                    <div v-if="mData.viewMode != 'detail'">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        Thả file vào đây hoặc <em>click để tải lên</em>
                      </div>
                    </div>
                  </el-upload>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <div class="rule_import">
                  <p class="mb-2 title bold">
                    <span class="c-red plus">* </span>Lưu ý khi nhập dữ liệu lương
                  </p>
                  <p class="subtitle">
                    - Cột "Mã nhân viên" trong file excel là định dạng Text
                  </p>
                  <p class="subtitle">
                    - Cột "Lương thực nhận" trong file excel là định dạng Number
                  </p>
                  <p class="subtitle">
                    - Header phải là 1 dòng (không có merge hàng, cột), là dòng đầu tiên
                    và dạng text
                  </p>
                  <p class="subtitle">
                    - Ngoài bắt buộc 2 cột: "Mã nhân viên" và "Lương thực nhận" có thể tuỳ
                    biến thêm các cột khác nhưng vẫn theo quy tắc trên
                  </p>
                  <p class="subtitle">
                    - Không nhập thêm các dòng text ngoài dữ liệu trong bảng
                  </p>
                  <span class="mt-2 download__css" @click="downloadTemplateImport">
                    Template nhập dữ liệu lương
                  </span>
                  <span class="mt-2 download__css ml-4" @click="downloadTaxTemplateImport">
                    Template nhập dữ liệu thuế
                  </span>
                  <span class="mt-2 download__css ml-4" @click="downloadInsuranceTemplateImport">
                    Template nhập dữ liệu bảo hiểm
                  </span>
                </div>
              </b-col>
            </b-row>
          </el-form>
        </div>
      </div>
    </div>
    <!-- Dialog thông tin lương -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="90%"
      top="30px"
      :before-close="beforeCloseDialogThongTinLuong"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div slot="title" class="d-flex1">
        <p>Kiểm tra</p>
      </div>
      <div>
        <div class="mb-2" v-if="typeFileUpload == 'dataExcel'">
          <el-form
            :model="mData.dataFormSalary"
            :rules="mData.validFormSalary"
            ref="importForm"
            label-width="160px"
            class="demo-ruleForm"
          >
            <b-row>
              <b-col md="4">
                <el-form-item label="Cột mã nhân viên" prop="employee_no">
                  <el-select
                    v-model="mData.dataFormSalary.employee_no"
                    placeholder=""
                    clearable
                    filterable
                    @change="changeColEmployeeNo"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listCollum"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item label="Cột thực nhận" prop="total_income">
                  <el-select
                    v-model="mData.dataFormSalary.total_income"
                    placeholder=""
                    clearable
                    filterable
                    @change="changeTotal"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listCollum"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="2">
                <el-checkbox
                  style="margin-top: 10px"
                  v-model="mData.dataFormSalary.is_deleted"
                  >Xóa dữ liệu cũ
                </el-checkbox>
              </b-col>
              <b-col md="2">
                <el-button
                  class="pl-2"
                  v-if="
                    mData.viewMode == 'update' &&
                    mData.dataDefault.listFeature.includes('FT1103')
                  "
                  :disabled="
                    mData.haveEmployeeNoError == true || mData.haveTotalError == true
                  "
                  round
                  @click="fn_checkImportSalary()"
                >
                  Lưu
                </el-button>
              </b-col>
            </b-row>
          </el-form>
        </div>
        <div class="mb-2 text-right" v-if="typeFileUpload == 'dataTaxExcel'">
          <el-button
            v-if="
              mData.viewMode == 'update' &&
              mData.dataDefault.listFeature.includes('FT1103')
            "
            :disabled="mData.haveEmployeeNoError"
            round
            @click="fn_checkImportTax()"
          >
            Lưu
          </el-button>
        </div>
        <div class="mb-2 text-right" v-if="typeFileUpload == 'dataInsuranceExcel'">
          <el-button
            v-if="
              mData.viewMode == 'update' &&
              mData.dataDefault.listFeature.includes('FT1103')
            "
            :disabled="mData.haveEmployeeNoError"
            round
            @click="fn_checkImportInsurance()"
          >
            Lưu
          </el-button>
        </div>
        <div class="main-body-table" style="max-height: calc(100vh - 260px)">
          <el-table
            :border="true"
            :data="mData[typeFileUpload]"
            style="width: 100%"
            :max-height="height"
          >
            <el-table-column
              v-for="(item, index) in mData[
                typeFileUpload == 'dataExcel'
                  ? 'dataExcelHeader'
                  : typeFileUpload == 'dataTaxExcel'
                  ? 'dataTaxExcelHeader'
                  : typeFileUpload == 'dataInsuranceExcel'
                  ? 'dataInsuranceExcelHeader'
                  : 'dataExcel'
              ]"
              :key="index"
              :prop="item"
              :label="item"
              min-width="180"
            >
              <template slot-scope="scope">
                <div
                  :class="
                    scope.row &&
                    scope.row[item] &&
                    !isNaN(scope.row[item]) &&
                    parseInt(scope.row[item]) > 1000
                      ? 'text-right'
                      : 'text-left1'
                  "
                >
                  {{
                    scope.row &&
                    scope.row[item] &&
                    !isNaN(scope.row[item]) &&
                    parseInt(scope.row[item]) > 1000
                      ? new Intl.NumberFormat("de-DE").format(scope.row[item])
                      : scope.row[item].toString()
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="total mt-3 d-flex">
          <p>
            Số nhân viên:
            <span class="bold">{{
              mData[
                typeFileUpload == "dataExcel"
                  ? "dataExcelBody"
                  : typeFileUpload == "dataTaxExcel"
                  ? "dataTaxExcelBody"
                  : typeFileUpload == "dataInsuranceExcel"
                  ? "dataInsuranceExcelBody"
                  : "dataExcelBody"
              ].length
            }}</span>
          </p>
          <p v-if="mData.totalSalary && mData.totalSalary != 'NaN'" class="ml-5">
            Tổng tiền: <span class="bold">{{ mData.totalSalary }}</span>
          </p>
        </div>
      </div>
    </el-dialog>
    <!-- Dialog lỗi khi lưu thông tin lương -->
    <el-dialog
      title="Lỗi nhập dữ liệu"
      :visible.sync="dialogErrorImportSalary"
      width="50%"
      top="25px"
      :before-close="closeDialogError"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <el-table :border="true" :data="mData.dataDefault.listError" style="width: 100%" class="table-error-message">
          <el-table-column prop="employee_no" label="Mã nhân viên" width="180">
          </el-table-column>
          <el-table-column prop="errors" label="Lỗi" min-width="180"> </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialogError">Đồng ý</el-button>
      </span>
    </el-dialog>

    <!-- Dialog lỗi cột khi lưu thông tin lương -->
    <el-dialog
      title="Lỗi"
      :visible.sync="dialogErrorImportSalaryTotal"
      width="40%"
      top="30px"
      :before-close="closeDialogErrorImportSalaryTotal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <el-table :border="true" :data="mData.dataErrorImport" style="width: 100%" class="table-error-message">
          <el-table-column prop="stt" label="Dòng thứ" width="80" align="center">
          </el-table-column>
          <el-table-column prop="employee_no" label="Mã nhân viên" min-width="180">
          </el-table-column>
          <el-table-column prop="total_income" label="Thực nhận" min-width="180">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialogErrorImportSalaryTotal"
          >Đồng ý</el-button
        >
      </span>
    </el-dialog>

    <!-- dialog xem chi tiết file  -->
    <el-dialog
      title="Chi tiết lương"
      :visible.sync="dialogShowDataDetail"
      width="70%"
      top="30px"
      height="440"
      :before-close="closeDialogShowDataDetail"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <el-table :border="true" :data="mData.dataExcel" style="width: 100%">
          <el-table-column
            v-for="(item, index) in mData.dataExcelHeader"
            :key="index"
            :prop="item"
            :label="item"
            min-width="180"
          >
            <template slot-scope="scope">
              <div
                :class="
                  index == 0
                    ? 'text-left'
                    : scope.row && scope.row[item] && !isNaN(scope.row[item])
                    ? 'text-right'
                    : 'text-left1'
                "
              >
                {{
                  scope.row[item] &&
                  parseInt(scope.row[item]) > 1000 &&
                  !isNaN(scope.row[item])
                    ? new Intl.NumberFormat("de-DE").format(scope.row[item])
                    : scope.row[item]
                    ? scope.row[item].toString()
                    : ""
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="downloadFile(mData.dataForm.file_id)">Tải File</el-button>
        <el-button type="primary" @click="closeDialogShowDataDetail">Đồng ý</el-button>
      </span>
    </el-dialog>

    <!-- Dialog lỗi trùng mã nhân viên -->
    <el-dialog
      title="Lỗi"
      :visible.sync="dialogErrorDulicateEmployeeNo"
      width="50%"
      top="25px"
      :before-close="closeDialogErrorDulicateEmployeeNo"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <el-table :border="true" :data="mData.dataDulicateEmployeeNo" style="width: 100%" class="table-error-message">
          <el-table-column prop="employee_no" label="Mã nhân viên" width="180">
          </el-table-column>
          <el-table-column prop="message" label="Lỗi" min-width="180"> </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialogErrorDulicateEmployeeNo"
          >Đồng ý</el-button
        >
      </span>
    </el-dialog>

    <!-- Dialog lỗi sai dữ liệu / trông cột tổng lương thực nhân -->
    <el-dialog
      title="Lỗi"
      :visible.sync="dialogErrorDulicateTotalIncone"
      width="50%"
      top="25px"
      :before-close="closeDialogErrorDulicateTotalIncone"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div>
        <el-table :border="true" :data="mData.dataDulicateTotalIncone" style="width: 100%" class="table-error-message">
          <el-table-column prop="message" label="Lỗi" min-width="180"> </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialogErrorDulicateTotalIncone"
          >Đồng ý</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ExtensionService from "../../../../service/ExtensionService";
import MethodService from "../../../../service/MethodService";
import ValidService from "../../../../service/ValidService";
import SalaryModel from "../SalaryModel";
import TemplateSalaryPeriodApi from "../../../../moduleApi/TemplateSalaryPeriodApi";
import SalaryPeriodApi from "../../../../moduleApi/SalaryPeriodApi";
import SalaryApi from "../../../../moduleApi/SalaryApi";
import TaxApi from "../../../../moduleApi/TaxApi";
import InsuranceApi from "../../../../moduleApi/InsuranceApi";
import EmployeeApi from "../../../../moduleApi/EmployeeApi";
import EmployeeRoleApi from "../../../../moduleApi/EmployeeRoleApi";
import FileApi from "../../../../moduleApi/FileApi";

export default {
  data() {
    return {
      height: window.innerHeight - 260,
      ValidService: ValidService,
      dialogVisible: false,
      typeFileUpload: undefined,
      dialogErrorImportSalary: false,
      dialogErrorImportSalaryTotal: false,
      dialogShowDataDetail: false,
      dialogErrorDulicateTotalIncone: false,
      dialogErrorDulicateEmployeeNo: false,
      dataDulicateTotalIncone: false,
      salaryPeriodConfig: false,
      mData: {
        isSealed: false,
        isSaveSalarySuccess: false, //Check xem có Import thành công hay không
        type: "",
        viewMode: "create",
        moduleName: "SalaryPeriod", //requied
        dataForm: MethodService.copyObject(SalaryModel.dataForm),
        validForm: SalaryModel.validForm,
        tableRules: MethodService.copyObject(SalaryModel.tableRules),
        dataFormSalary: {
          employee_no: undefined,
          salary_period_id: undefined,
          total_income: undefined,
          customFields: undefined,
          is_deleted: false,
        },
        validFormSalary: {
          employee_no: [ValidService.requiredChange],
          salary_period_id: [],
          total_income: [ValidService.requiredChange],
          customFields: [],
        },
        isImportSalary: false,
        totalSalary: "",
        dataExcel: [],
        dataExcelHeader: [],
        dataExcelBody: [],
        //Tax
        dataTaxExcel: [],
        dataTaxExcelHeader: [],
        dataTaxExcelBody: [],
        //Insurance
        dataInsuranceExcel: [],
        dataInsuranceExcelHeader: [],
        dataInsuranceExcelBody: [],
        dataErrorImport: [],
        dataDetailExcel: [],
        dataDulicateEmployeeNo: [],
        dataDulicateTotalIncone: [],
        previousFileId: "",
        dataSalaryPeriod: {},
        dataSalary: {},
        dataTax: {},
        dataInsurance: {},
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listSealedLevel: [
            {
              value: 1,
              label: "1",
            },
            {
              value: 2,
              label: "2",
            },
            {
              value: 3,
              label: "3",
            },
          ],
          listSaledUserIds: [],
          listEmployeeExports: [],
          listSalaryPeriod: [],
          listSealedUsers: [],
          listCollum: [],
          listError: [],
          listErrorCell: [],
          listErrorDublicateEmployeeMo: [],
        },
        currentUser: MethodService.getCurrentUser(),
        fileUploadOption: {
          Template: {
            limit: 1,
            accept: ".xlsx, .xls",
            dialogVisible: false,
            fileList: [],
          },
          Tax: {
            limit: 1,
            accept: ".xlsx, .xls",
            dialogVisible: false,
            fileList: [],
          },
          Insurance: {
            limit: 1,
            accept: ".xlsx, .xls",
            dialogVisible: false,
            fileList: [],
          },
        },
        haveEmployeeNoError: false,
        haveTotalError: false,
      },
      typeFileExcel: ["xlsx", "xls"],
      check: false,
    };
  },

  methods: {
    async downloadTemplateImport() {
      MethodService.exportTemplateImportSalary(
        this.mData.dataDefault.listEmployeeExports
      );
    },
    async downloadTaxTemplateImport() {
      MethodService.exportTemplateImportTax(this.mData.dataDefault.listEmployeeExports)
    },
    async downloadInsuranceTemplateImport() {
      MethodService.exportTemplateImportInsurance(this.mData.dataDefault.listEmployeeExports)
    },
    checkNull() {
      this.$refs["mySalaryPeriodForm"].validate(async (valid) => {
        if (!valid) {
          this.check = true;
        } else {
          this.check = false;
        }
      });
    },
    async fn_initDataDefault() {
      const templateSalaryPeriodApiRes = await TemplateSalaryPeriodApi.list(
        { limit: 1000 },
        true
      );
      const employeeApiRes = await EmployeeApi.list(
        {
          filters: "status!=DA_NGHI",
          sort: "administrative_info.name.first_name",
          limit: 10000,
        },
        true
      );
      this.mData.dataDefault.listEmployeeExports = employeeApiRes.result;
      this.mData.dataDefault.listSalaryPeriod = templateSalaryPeriodApiRes.result;
      if (this.mData.viewMode == "update") {
        const listSealedUsersRes = await EmployeeRoleApi.getListEmployeeHasApproveSalaryPeriod();
        listSealedUsersRes.result.forEach((item, index) => {
          if (item.e) {
            this.mData.dataDefault.listSealedUsers.push(item.e);
          }
        });
        this.mData.dataDefault.listSealedUsers = [
          ...new Map(
            this.mData.dataDefault.listSealedUsers.map((item) => [item.id, item])
          ).values(),
        ];
      } else if (this.mData.viewMode == "detail") {
        const listSealedUsersRes = await EmployeeApi.list({ limit: 10000 }, true);
        this.mData.dataDefault.listSealedUsers = listSealedUsersRes.result;
      }
    },
    async fn_getDataById(id) {
      const res = await SalaryPeriodApi.findById(id);
      if (res.result) {
        if (res.result.sealed_users && res.result.sealed_users.length > 0) {
          let keys_to_keep = ["sealed_user_id"];
          this.mData.dataDefault.listSaledUserIds = res.result.sealed_users.map((e) => {
            const obj = {};
            keys_to_keep.forEach((k) => (obj[k] = e[k]));
            return obj.sealed_user_id;
          });
        }
        if (res.result.config) {
          this.salaryPeriodConfig = res.result.config;
        }
        this.mData.dataForm = res.result;
        if (this.salaryPeriodConfig === false) {
          if (this.mData.dataForm.sealed_level == 0) {
            this.mData.dataForm.sealed_level = "";
            if (this.$refs["mySalaryPeriodForm"].fields.find((f) => f.prop == "sealed_level")) {
              this.$refs["mySalaryPeriodForm"].fields
                .find((f) => f.prop == "sealed_level")
                .resetField();
            }
          }
        }
        if (this.mData.dataForm.file_id) {
          this.mData.previousFileId = this.mData.dataForm.file_id;
          let data = {};
          const fileRes = await FileApi.findById(this.mData.dataForm.file_id);
          data = fileRes.result;
          this.mData.fileUploadOption.Template.fileList.push(data);
        }
        if (this.mData.dataForm.tax_file_id) {
          let data = {};
          const fileRes = await FileApi.findById(this.mData.dataForm.tax_file_id);
          data = fileRes.result;
          this.mData.fileUploadOption.Tax.fileList.push(data);
        }
        if (this.mData.dataForm.insurance_file_id) {
          let data = {};
          const fileRes = await FileApi.findById(this.mData.dataForm.insurance_file_id);
          data = fileRes.result;
          this.mData.fileUploadOption.Insurance.fileList.push(data);
        }
        if (
          this.mData.dataForm.sealed === 'APPROVED' ||
          this.mData.dataForm.sealed === 'REJECTED'
        ) {
          this.mData.isSealed = true;
        }
        if (this.mData.dataForm.sealed_level === 0) {
          this.mData.dataForm.sealed_level = "";
        }
      }
    },
    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initData();
    },
    async submitForm(type) {
      if (type == "approval") {
        this.$confirm("Bạn có chắc chắn muốn duyệt bảng lương này không?", "Thông báo", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "info",
        })
          .then(async () => {
            let data = {
              id: this.mData.dataForm.id,
            };
            try {
              await SalaryPeriodApi.ApprovalSalaryTable(data);
              window.toastr.success("Duyệt bảng lương thành công!");
              this.fn_go();
            } catch (error) {
              if (error.meta && error.meta.field) {
                window.toastr.error(error.meta.field);
              } else {
                window.toastr.error("Duyệt bảng lương thất bại!");
              }
            }
          })
          .catch(() => {});
      } else if (type == "unApproval") {
        this.$confirm(
          "Bạn có chắc chắn muốn từ chối bảng lương này không?",
          "Thông báo",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "info",
          }
        )
          .then(async () => {
            let data = {
              id: this.mData.dataForm.id,
            };
            try {
              await SalaryPeriodApi.UnAppovalSalaryTable(data);
              window.toastr.success("Từ chối duyệt bảng lương thành công!");
              this.fn_go();
            } catch (error) {
              if (error.meta && error.meta.field) {
                window.toastr.error(error.meta.field);
              } else {
                window.toastr.error("Từ chối duyệt bảng lương thất bại!");
              }
            }
          })
          .catch(() => {});
      } else {
        this.$refs["mySalaryPeriodForm"].validate(async (valid) => {
          if (!this.mData.dataForm.file_id) {
            window.toastr.warning('Vui lòng tải File lương')
            return
          }
          if (!this.mData.dataForm.tax_file_id) {
            window.toastr.warning('Vui lòng tải File thuế')
            return
          }
          if (!this.mData.dataForm.insurance_file_id) {
            window.toastr.warning('Vui lòng tải File bảo hiểm')
            return
          }
          if (valid) {
            if (type == "import") {
              this.$confirm(
                "Bạn có chắc chắn muốn chuyển duyệt bảng lương này không?",
                "Thông báo",
                {
                  confirmButtonText: "Đồng ý",
                  cancelButtonText: "Hủy",
                  type: "info",
                }
              )
                .then(async () => {
                  let data = {};
                  let dataUpdateSalaryPeriod = this.mData.dataForm;
                  data.id = this.mData.dataForm.id;
                  dataUpdateSalaryPeriod.sealed_users = dataUpdateSalaryPeriod.sealed_users.map((e) => {
                    return {
                      sealed_user_id: e.sealed_user_id,
                    }
                  });
                  try {
                    await SalaryPeriodApi.update(dataUpdateSalaryPeriod);
                    await SalaryPeriodApi.AssignToApprover(data);
                    await TaxApi.ImportTax(this.mData.dataTax);
                    await InsuranceApi.ImportInsurance(this.mData.dataInsurance);
                    await SalaryApi.ImportSalary(this.mData.dataSalary);
                    window.toastr.success("Chuyển duyệt bảng lương thành công");
                    this.fn_go();
                  } catch (error) {
                    window.toastr.error("Chuyển duyệt bảng lương thất bại!");
                  }
                })
                .catch(() => {});
            } else if (type == "importSalaryNoApproval") {
              try {
                this.$confirm(
                  this.salaryPeriodConfig === false
                    ? "Bạn có chắc chắn muốn lưu thông tin lương. Thông tin lương sau khi lưu sẽ gửi thông tin cho nhân viên!"
                    : "Bạn có chắc chắn muốn lưu thông tin lương!",
                  "Thông báo",
                  {
                    confirmButtonText: "Đồng ý",
                    cancelButtonText: "Hủy",
                    type: "info",
                  }
                )
                  .then(async () => {
                    await TaxApi.ImportTax(this.mData.dataTax);
                    await InsuranceApi.ImportInsurance(this.mData.dataInsurance);
                    await SalaryPeriodApi.update(this.mData.dataSalaryPeriod);
                    await SalaryApi.ImportSalary(this.mData.dataSalary);
                    window.toastr.success("Lưu thông tin lương thành công");
                    this.fn_go();
                  })
                  .catch(() => {});
              } catch (error) {
                window.toastr.error("Lưu thông tin lương thất bại!");
              }
              this.$refs["importForm"].resetFields();
            }
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
    },
    changeSealedLevel() {
      this.mData.dataForm.sealed_users = [];
      this.mData.validForm.sealed_users = [];
      for (let i = 0; i < this.mData.dataForm.sealed_level; i++) {
        this.mData.dataForm.sealed_users.push({
          sealed_user_id: undefined,
          // is_sealed: "WAITING_FOR_APPROVAL"
        });
        this.mData.validForm.sealed_users.push({
          sealed_user_id: [ValidService.requiredChange],
          sealed_at: [],
          is_sealed: [],
        });
      }
      this.forceUpdateUI();
    },
    changeSealedUser(user, index) {
      if (user) {
        this.mData.validForm.sealed_users[index] = {
          sealed_user_id: [], // required Người chốt
          sealed_at: [], // optional Thời điểm chốt
          is_sealed: [],
        };
        this.$refs["mySalaryPeriodForm"].clearValidate(`sealed_users[` + index + `].sealed_user_id`);
      } else {
        this.mData.validForm.sealed_users[index] = {
          sealed_user_id: [ValidService.requiredChange], // required Người chốt
          sealed_at: [], // optional Thời điểm chốt
          is_sealed: [],
        };
      }
    },
    //Upload file
    async fn_readFileExcel(file, arrHeader, arrBody, typeFileUpload) {
      try {
        let valueFile = await MethodService.readExcel(file.raw);
        this.mData[arrHeader] = valueFile[0] || [];
        this.mData[arrBody] = valueFile.splice(1, valueFile.length);
        this.fn_changeDataFromArrToObj(
          this.mData[arrHeader],
          this.mData[arrBody],
          typeFileUpload
        );
        setTimeout(() => {
          this.dialogVisible = true;
          this.typeFileUpload = typeFileUpload;
        }, 600);
      } catch (error) {
        console.log("error", error);
      }
    },
    fn_changeDataFromArrToObj(arHeader, arrBody, typeArrPushData) {
      this.mData[typeArrPushData] = [];
      arHeader.forEach((e, i) => {
        if (!e) {
          arHeader[i] = "Cột " + (i + 1);
        }
      });
      arrBody.forEach((item) => {
        let obj = {};
        item.forEach((e, i) => {
          if (i === this.mData.dataFormSalary.employee_no && e != undefined) {
            obj[arHeader[i]] = e.toString().toUpperCase();
          } else {
            obj[arHeader[i]] = e != undefined ? e.toString() : "";
          }
        });
        this.mData[typeArrPushData].push(obj);
      })
      if (typeArrPushData != "dataExcel") {
        setTimeout(() => {
          this.checkEmployeeNoImport(typeArrPushData)
        }, 1000)
        return
      }
      this.mData.dataDefault.listCollum = [];
      arHeader.forEach((item, index) => {
        this.mData.dataDefault.listCollum.push({
          value: index,
          label: item,
        });
      });
    },
    changeColEmployeeNo() {
      if (this.mData.dataFormSalary.employee_no === "") {
        this.mData.dataExcelBody.forEach((item, index) => {
          this.removeClassError(index, "error-row_employee")
        })
        return
      }
      let objDulicateEmNo = {}
      let error = false
      let colEmployeeNo = this.mData.dataFormSalary.employee_no
      this.mData.dataExcelBody.forEach((item, index) => {
        this.removeClassError(index, "error-row_employee")
        if (!item[colEmployeeNo]) {
          error = true
          this.addClassError(index, 'error-row_employee')
        } else {
          if (!(item[colEmployeeNo] in objDulicateEmNo)) {
            objDulicateEmNo[item[colEmployeeNo]] = []
            objDulicateEmNo[item[colEmployeeNo]].push(index)
          } else {
            objDulicateEmNo[item[colEmployeeNo]].push(index)
          }
        }
      })
      for (const [key, value] of Object.entries(objDulicateEmNo)) {
        if (value.length > 1) {
          value.forEach(index => {
            error = true
            this.addClassError(index, 'error-row_employee')
          })
          let messageError = {}
          messageError["employee_no"] = key
          messageError[
            "message"
          ] = `Mã nhân viên ${key} đang bị trùng tại dòng ${value.map(x => x + 2).join(", ")}`
          this.mData.dataDulicateEmployeeNo.push(messageError)
        }
      }
      if (this.mData.dataDulicateEmployeeNo.length > 0) this.dialogErrorDulicateEmployeeNo = true
      this.mData.haveEmployeeNoError = error
    },
    changeTotal() {
      if (this.mData.dataFormSalary.total_income === "") {
        this.mData.dataExcelBody.forEach((item, index) => {
          this.removeClassError(index, "error-row")
        })
        return
      }
      let objErrorTotal = {}
      let error = false
      let colTotalIncome = this.mData.dataFormSalary.total_income
      this.mData.dataExcelBody.forEach((item, index) => {
        this.removeClassError(index, "error-row")
        if (
          typeof item[colTotalIncome] != "number" ||
          isNaN(parseInt(item[colTotalIncome]))
        ) {
          error = true
          this.addClassError(index, 'error-row')
          // console.log('item[colTotalIncome]', item[colTotalIncome]);
          if (!(item[colTotalIncome] in objErrorTotal)) {
            objErrorTotal[item[colTotalIncome]] = []
            objErrorTotal[item[colTotalIncome]].push(index)
          } else {
            objErrorTotal[item[colTotalIncome]].push(index)
          }
        }
      })
      for (const [key, value] of Object.entries(objErrorTotal)) {
        if (value) {
          value.forEach(index => {
            error = true
            this.addClassError(index, 'error-row')
          })
          let messageError = {}
          if (key == 'null') {
            messageError[
              "message"
            ] = `Giá trị Tổng lương thực nhận đang bị trống tại dòng ${value.map(x => x + 2).join(", ")}`
          } else {
            messageError[
              "message"
            ] = `Giá trị Tổng lương thực nhận tại dòng ${value.map(x => x + 2).join(", ")} bị sai dịnh dạng`
          }
          this.mData.dataDulicateTotalIncone.push(messageError)
        }
      }
      this.mData.haveTotalError = error
      if (this.mData.dataDulicateTotalIncone.length > 0) {
        this.dialogErrorDulicateTotalIncone = true
        return
      }
      let total = 0
      this.mData.dataExcelBody.forEach((item) => {
        total +=
          typeof item[colTotalIncome] == "number"
            ? item[colTotalIncome]
            : parseInt(item[colTotalIncome])
      })
      this.mData.totalSalary = MethodService.formatCurrency(total)
    },
    removeClassError(index, className) {
      document.getElementsByTagName("tbody")[0].children[index].classList.remove(className)
    },
    addClassError(index, className) {
      document.getElementsByTagName("tbody")[0].children[index].classList.add(className)
    },
    validateFieldMethod(prop) {
      this.$refs['mySalaryPeriodForm'].validateField(prop)
    },
    async fn_uploadFileSalaryPeriod(file, fileList) {
      if (
        !this.typeFileExcel.includes(
          file.name
            .substr(file.name.length - 4, 4)
            .replace(".", "")
            .toLowerCase()
        )
      ) {
        window.toastr.error("File không đúng định dạng!");
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
        return;
      }
      if (this.mData.dataForm.file_id) {
        this.$confirm(
          "Bạn đã Import file lương, bạn có chắc muốn Import lại?",
          "Warning",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "Cảnh báo",
          }
        )
          .then(() => {
            this.fn_upload(file, fileList);
          })
          .catch(() => {
            fileList.forEach((el, i) => {
              if (el.uid == file.uid) {
                fileList.splice(i, 1);
              }
            });
          });
      } else {
        this.fn_upload(file, fileList);
      }
    },
    async fn_upload(file, fileList) {
      await this.fn_readFileExcel(file, "dataExcelHeader", "dataExcelBody", "dataExcel");
      try {
        const res = await ExtensionService.upload(file, ["ImportSalaryPeriod"]);
        this.mData.dataForm.file_id = res.result;
        if (fileList.length > 1) {
          delete fileList[0];
        }
        this.mData.totalSalary = "";
        fileList.forEach((el) => {
          if (el.uid == file.uid) {
            el.id = res.result;
          }
        });
        this.mData.fileUploadOption.Template.fileList = fileList;
        this.$refs["mySalaryPeriodForm"].clearValidate("file_id");
        // this.validateFieldMethod("file_id")
      } catch (error) {
        this.$refs["mySalaryPeriodForm"].validateField("file_id");
        // this.validateFieldMethod("file_id")
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
      }
    },
    //Import salary
    fn_checkImportSalary() {
      this.mData.dataDefault.listErrorCell = [];
      this.$refs["importForm"].validate(async (valid) => {
        let isInvalid = false;
        if (valid) {
          let data = {
            salary_period_id: this.mData.dataForm.id,
            headers: this.mData.dataExcelHeader,
            salaries: [],
            is_deleted: this.mData.dataFormSalary.is_deleted,
          };
          this.mData.dataExcelBody.forEach((item, index) => {
            if (typeof item[this.mData.dataFormSalary.total_income] != "number") {
              item.push(index + 1);
              isInvalid = true;
              this.mData.dataDefault.listErrorCell.push(item);
            }
            if (!item[this.mData.dataFormSalary.employee_no]) {
              item.push(index + 1);
              isInvalid = true;
              this.mData.dataDefault.listErrorCell.push(item);
            }
            if (!isInvalid) {
              item[this.mData.dataFormSalary.employee_no] = item[
                this.mData.dataFormSalary.employee_no
              ]
                .toString()
                .toUpperCase();
              data.salaries.push({
                employee_no: item[this.mData.dataFormSalary.employee_no]
                  .toString()
                  .toUpperCase(),
                total_income: item[this.mData.dataFormSalary.total_income],
                values: item,
              });
            }
          });
          if (isInvalid === true) {
            this.mData.dataDefault.listErrorCell.forEach((item) => {
              let obj = {
                employee_no: item[this.mData.dataFormSalary.employee_no]
                  .toString()
                  .toUpperCase(),
                total_income: item[this.mData.dataFormSalary.total_income],
                stt: item[item.length - 1],
              };
              this.mData.dataErrorImport.push(obj);
            });
            this.dialogErrorImportSalaryTotal = true;
            return;
          }
          let dataSalaryPeriod = this.mData.dataForm;
          if (this.salaryPeriodConfig === false) {
            dataSalaryPeriod.sealed = "APPROVED";
            dataSalaryPeriod.sealed_level = 0;
          } else {
            dataSalaryPeriod.sealed = "NEW";
          }
          const checkImportSalaryRes = await SalaryApi.CheckImportSalary(data);
          if (checkImportSalaryRes.result.listError.length > 0) {
            this.mData.dataDefault.listError = checkImportSalaryRes.result.listError;
            this.dialogVisible = true;
            this.dialogErrorImportSalary = true;
            this.mData.totalSalary = undefined
          } else if (checkImportSalaryRes.result.listError.length == 0) {
            this.mData.dataSalaryPeriod = dataSalaryPeriod;
            this.mData.dataSalary = data;
            this.mData.isImportSalary = true;
            this.dialogVisible = false;
            this.mData.dataDefault.listCollum = [];
            this.mData.dataExcelHeader = [];
            this.mData.dataExcelBody = [];
            this.mData.dataExcel = [];
            this.mData.totalSalary = undefined
            this.$refs["importForm"].resetFields();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    //Import Tax
    async fn_checkImportTax() {
      this.mData.dataDefault.listErrorCell = [];
      let isInvalid = false;
      let dataTax = {
        salary_period_id: this.mData.dataForm.id,
        taxes: []
      }
      this.mData.dataTaxExcelBody.forEach((item, index) => {
        item.forEach((e, i) => {
          if (i < 2) return
          if (e != null && typeof e != "number") {
            item.push(index + 1)
            isInvalid = true
            this.mData.dataDefault.listErrorCell.push(item);
          }
        });
        if (!isInvalid) {
          let dataItemObj = {
            employee_no: item[0],
            income_tax: item[2],
            family_allowances: item[3],
            donate: item[4],
            compulsory_insurance: item[5],
            taxable_income: item[6],
            reduction_rate: item[7],
          }
          dataTax.taxes.push(dataItemObj)
        }
      })
      if (isInvalid === true) return

      const checkImportTaxRes = await TaxApi.CheckImportTax(dataTax)
      if (checkImportTaxRes.result.listError.length > 0) {
        this.mData.dataDefault.listError = checkImportTaxRes.result.listError
        this.dialogVisible = true
        this.dialogErrorImportSalary = true
      } else if (checkImportTaxRes.result.listError.length == 0) {
        this.mData.dataTax = dataTax
        this.dialogVisible = false
        this.mData.dataTaxExcelHeader = []
        this.mData.dataTaxExcelBody = []
        this.mData.dataTaxExcel = []
      }
    },
    //Import Insurance
    async fn_checkImportInsurance() {
      this.mData.dataDefault.listErrorCell = [];
      let isInvalid = false;
      let dataInsurance = {
        salary_period_id: this.mData.dataForm.id,
        insurances: []
      }
      this.mData.dataInsuranceExcelBody.forEach((item, index) => {
        item.forEach((e, i) => {
          if (i < 2) return
          if (e != null && typeof e != "number") {
            item.push(index + 1)
            isInvalid = true
            this.mData.dataDefault.listErrorCell.push(item);
          }
        });
        if (!isInvalid) {
          let dataItemObj = {
            employee_no: item[0],
            social_insurance: item[2],
            health_insurance: item[3],
            unemployment_insurance: item[4],
          }
          dataInsurance.insurances.push(dataItemObj)
        }
      })
      if (isInvalid === true) return

      const checkImportInsuranceRes = await InsuranceApi.CheckImportInsurance(dataInsurance)
      if (checkImportInsuranceRes.result.listError.length > 0) {
        this.mData.dataDefault.listError = checkImportInsuranceRes.result.listError
        this.dialogVisible = true
        this.dialogErrorImportSalary = true
      } else if (checkImportInsuranceRes.result.listError.length == 0) {
        this.mData.dataInsurance = dataInsurance
        this.dialogVisible = false
        this.mData.dataInsuranceExcelHeader = []
        this.mData.dataInsuranceExcelBody = []
        this.mData.dataInsuranceExcel = []
      }
    },
    fn_removeFileSalaryPeriod(file, fileList) {
      this.mData.dataForm.file_id = null;
      this.mData.fileUploadOption.Template.fileList = [];
      this.mData.dataDefault.listCollum = [];
      this.mData.dataExcelHeader = [];
      this.mData.dataExcelBody = [];
      this.mData.dataExcel = [];
      this.validateFieldMethod("file_id")
    },
    downloadFile(fileId) {
      window.open(ExtensionService.urlDowloadFile + fileId);
    },
    //Tax
    async fn_uploadFileTax(file, fileList) {
      if (
        !this.typeFileExcel.includes(
          file.name
            .substr(file.name.length - 4, 4)
            .replace(".", "")
            .toLowerCase()
        )
      ) {
        window.toastr.error("File không đúng định dạng!");
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
        return;
      }
      if (this.mData.dataForm.tax_file_id) {
        this.$confirm(
          "Bạn đã Import file lương, bạn có chắc muốn Import lại?",
          "Warning",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "Cảnh báo",
          }
        )
          .then(() => {
            this.fn_uploadTax(file, fileList);
          })
          .catch(() => {
            fileList.forEach((el, i) => {
              if (el.uid == file.uid) {
                fileList.splice(i, 1);
              }
            });
          });
      } else {
        this.fn_uploadTax(file, fileList);
      }
    },
    async fn_uploadTax(file, fileList) {
      await this.fn_readFileExcel(
        file,
        "dataTaxExcelHeader",
        "dataTaxExcelBody",
        "dataTaxExcel"
      );
      try {
        const res = await ExtensionService.upload(file, ["Tax"]);
        this.mData.dataForm.tax_file_id = res.result;
        if (fileList.length > 1) {
          delete fileList[0];
        }
        fileList.forEach((el) => {
          if (el.uid == file.uid) {
            el.id = res.result;
          }
        });
        this.mData.fileUploadOption.Tax.fileList = fileList;
        this.$refs["mySalaryPeriodForm"].clearValidate("tax_file_id");
        // this.validateFieldMethod("tax_file_id")
      } catch (error) {
        this.$refs["mySalaryPeriodForm"].validateField("tax_file_id");
        // this.validateFieldMethod("tax_file_id")
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
      }
    },
    checkEmployeeNoImport(typeArrPushData) {
      let objDulicateEmNo = {}
      let error = false
      this.mData[
        typeArrPushData == "dataExcel"
          ? 'dataExcelBody'
          : typeArrPushData == "dataTaxExcel"
            ? "dataTaxExcelBody"
            : "dataInsuranceExcelBody"
      ].forEach((item, index) => {
        this.removeClassError(index, 'error-row_employee')
        if (!item[0]) {
          error = true
          this.addClassError(index, 'error-row_employee')
          let messageError = {}
          messageError["employee_no"] = undefined
          messageError[
            "message"
          ] = `Mã nhân viên đang bị trống tại dòng ${index + 2}`
          this.mData.dataDulicateEmployeeNo.push(messageError)
        } else {
          if (!(item[0] in objDulicateEmNo)) {
            objDulicateEmNo[item[0]] = []
            objDulicateEmNo[item[0]].push(index)
          } else {
            objDulicateEmNo[item[0]].push(index)
          }
        }
        for (let i = 2; i < item.length; i++) {
          if (item[i] != null && typeof item[i] != 'number') {
            error = true
            this.addClassError(index, 'error-row_employee')
          }
        }
      })
      for (const [key, value] of Object.entries(objDulicateEmNo)) {
        if (value.length > 1) {
          value.forEach((e) => {
            error = true
            this.addClassError(e, 'error-row_employee')
          })
          let messageError = {}
          messageError["employee_no"] = key
          messageError[
            "message"
          ] = `Mã nhân viên ${key} đang bị trùng tại dòng ${value
            .map((x) => x + 2)
            .join(", ")}`
          this.mData.dataDulicateEmployeeNo.push(messageError)
        }
      }
      if (this.mData.dataDulicateEmployeeNo.length > 0) this.dialogErrorDulicateEmployeeNo = true
      this.mData.haveEmployeeNoError = error
    },
    fn_removeFileTax(file, fileList) {
      this.mData.dataForm.tax_file_id = null;
      this.mData.fileUploadOption.Tax.fileList = [];
      this.mData.dataTaxExcelHeader = [];
      this.mData.dataTaxExcelBody = [];
      this.mData.dataTaxExcel = [];
      this.validateFieldMethod("tax_file_id")
    },
    fn_previewFileTax() {
      if (this.mData.viewMode == 'update') return
      this.downloadFile(this.mData.dataForm.tax_file_id)
    },
    //Bảo hiểm
    async fn_uploadFileInsurance(file, fileList) {
      if (
        !this.typeFileExcel.includes(
          file.name
            .substr(file.name.length - 4, 4)
            .replace(".", "")
            .toLowerCase()
        )
      ) {
        window.toastr.error("File không đúng định dạng!");
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
        return;
      }
      if (this.mData.dataForm.insurance_file_id) {
        this.$confirm(
          "Bạn đã Import file lương, bạn có chắc muốn Import lại?",
          "Warning",
          {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy",
            type: "Cảnh báo",
          }
        )
          .then(() => {
            this.fn_upload(file, fileList);
          })
          .catch(() => {
            fileList.forEach((el, i) => {
              if (el.uid == file.uid) {
                fileList.splice(i, 1);
              }
            });
          });
      } else {
        this.fn_uploadInsurance(file, fileList);
      }
    },
    async fn_uploadInsurance(file, fileList) {
      await this.fn_readFileExcel(
        file,
        "dataInsuranceExcelHeader",
        "dataInsuranceExcelBody",
        "dataInsuranceExcel"
      );
      try {
        const res = await ExtensionService.upload(file, ["Insurance"]);
        this.mData.dataForm.insurance_file_id = res.result;
        if (fileList.length > 1) {
          delete fileList[0];
        }
        fileList.forEach((el) => {
          if (el.uid == file.uid) {
            el.id = res.result;
          }
        });
        this.mData.fileUploadOption.Insurance.fileList = fileList;
        this.$refs["mySalaryPeriodForm"].clearValidate("insurance_file_id");
        // this.validateFieldMethod("insurance_file_id")
      } catch (error) {
        this.$refs["mySalaryPeriodForm"].validateField("insurance_file_id");
        // this.validateFieldMethod("insurance_file_id")
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
      }
    },
    fn_removeFileInsurance(file, fileList) {
      this.mData.dataForm.insurance_file_id = null;
      this.mData.fileUploadOption.Insurance.fileList = [];
      this.mData.dataInsuranceExcelHeader = [];
      this.mData.dataInsuranceExcelBody = [];
      this.mData.dataInsuranceExcel = [];
      this.validateFieldMethod("insurance_file_id")
    },
    fn_previewFileInsurance() {
      if (this.mData.viewMode == 'update') return
      this.downloadFile(this.mData.dataForm.insurance_file_id)
    },
    async fn_previewFileSalaryPeriod() {
      if (this.mData.viewMode == 'update') return
      this.downloadFile(this.mData.dataForm.file_id)
    },
    closeDialogShowDataDetail() {
      this.dialogShowDataDetail = false
    },
    beforeCloseDialogThongTinLuong() {
      if (this.typeFileUpload == "dataExcel") {
        this.$refs["importForm"].resetFields();
        this.mData.dataDefault.listCollum = [];
      }
      this.mData.dataForm[
        this.typeFileUpload == "dataExcel"
          ? "file_id"
          : this.typeFileUpload == "dataTaxExcel"
          ? "tax_file_id"
          : this.typeFileUpload == "dataInsuranceExcel"
          ? "insurance_file_id"
          : ""
      ] = null
      this.mData.fileUploadOption[
        this.typeFileUpload == "dataExcel"
          ? "Template"
          : this.typeFileUpload == "dataTaxExcel"
          ? "Tax"
          : this.typeFileUpload == "dataInsuranceExcel"
          ? "Insurance"
          : ""
      ].fileList = []
      this.mData[
        this.typeFileUpload == "dataExcel"
          ? "dataExcelHeader"
          : this.typeFileUpload == "dataTaxExcel"
          ? "dataTaxExcelHeader"
          : this.typeFileUpload == "dataInsuranceExcel"
          ? "dataInsuranceExcelHeader"
          : ""
      ] = []
      this.mData[
        this.typeFileUpload == "dataExcel"
          ? "dataExcelBody"
          : this.typeFileUpload == "dataTaxExcel"
          ? "dataTaxExcelBody"
          : this.typeFileUpload == "dataInsuranceExcel"
          ? "dataInsuranceExcelBody"
          : ""
      ] = []
      this.mData[
        this.typeFileUpload == "dataExcel"
          ? "dataExcel"
          : this.typeFileUpload == "dataTaxExcel"
          ? "dataTaxExcel"
          : this.typeFileUpload == "dataInsuranceExcel"
          ? "dataInsuranceExcel"
          : ""
      ] = []
      this.mData.totalSalary = undefined
      this.dialogVisible = false;
    },
    closeDialogError() {
      this.mData.dataDefault.listError = [];
      this.dialogErrorImportSalary = false;
    },
    closeDialogErrorImportSalaryTotal() {
      this.mData.dataErrorImport = [];
      this.dialogErrorImportSalaryTotal = false;
    },
    fn_go() {
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    handleBlur(prop) {
      this.$refs["mySalaryPeriodForm"].validateField(prop);
    },
    closeDialogErrorDulicateEmployeeNo() {
      this.mData.dataDulicateEmployeeNo = [];
      this.dialogErrorDulicateEmployeeNo = false;
    },
    closeDialogErrorDulicateTotalIncone() {
      this.mData.dataDulicateTotalIncone = [];
      this.dialogErrorDulicateTotalIncone = false;
    },
  },

  created() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-Salary-" + this.mData.moduleName + "-SalaryPeriodList-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-Salary-" + this.mData.moduleName + "-SalaryPeriodList-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.custom_label_requied::after {
  content: "*";
  color: #fa4949;
  margin-left: 4px;
  font-weight: 700;
}
::v-deep .check-box_sequential .el-form-item__content {
  margin-top: 10px;
}

::v-deep .el-table__body-wrapper {
  max-height: calc(100vh - 295px);
}

.d-flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
}

.d-flex1 p {
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--white);
}

.button-css {
  margin-right: 30px;
}

.total p {
  font-size: 15px;
}

::v-deep .error-row {
  background-color: #ffd7d7 !important;
}

::v-deep .error-row:hover {
  background-color: #ffd7d7 !important;
}

::v-deep .error-row_employee {
  background-color: #ffd7d7 !important;
}

::v-deep .error-row_employee:hover {
  background-color: #ffd7d7 !important;
}

::v-deep .el-dialog__body {
  max-height: calc(100vh - 100px);
}

::v-deep .diable .el-upload .el-upload-dragger:hover {
  border-color: #d9d9d9;
  cursor: not-allowed;
}

::v-deep .el-table.table-error-message {
  tbody tr {
    .cell {
      white-space: unset;
    }
  }
}
.rule_import {
  p {
    font-size: 15px;
    margin-bottom: 2px;
  }

  .title {
    font-size: 17px;
  }
}
@media (max-width: 1730px) and (min-width: 1600px) {
  ::v-deep .el-upload-dragger {
    width: 320px;
  }
}
@media (max-width: 1599px) and (min-width: 1470px) {
  ::v-deep .el-upload-dragger {
    width: 280px;
    padding: 0 20px;
  }
}
@media (max-width: 1469px) and (min-width: 1340px) {
  ::v-deep .el-upload-dragger {
    width: 230px;
    padding: 0 20px;
    .el-icon-upload {
      margin-top: 25px;
    }
  }
}
@media (max-width: 1339px) and (min-width: 1210px) {
  ::v-deep .el-upload-dragger {
    width: 190px;
    padding: 0 20px;
    .el-icon-upload {
      margin-top: 25px;
    }
  }
}
@media (max-width: 1209px) and (min-width: 1100px) {
  ::v-deep .el-upload-dragger {
    width: 150px;
    padding: 0 20px;
    .el-icon-upload {
      margin-top: 17px;
    }
  }
}
</style>
